import backofficeService from './backoffice';

const load = async path => {
  const response = await backofficeService.Api().get(path);
  const data = (response && response.data && (response.data.data || response.data)) || {};
  const publishableKey = data.publishableKey || data.key || '';
  if (!publishableKey) throw new Error('Stripe payment setup is unavailable for this billing account.');
  return { ...data, publishableKey };
};

export default {
  getSignupConfig() { return load('signup/stripe-config'); },
  getOrganizationConfig() { return load('stripe/config'); },
};
